export const errorMessage = {
  oops: 'Oops! something went wrong!',
  emptyUsername: 'Username is required',
  emptyPassword: 'Password is required',
  emptyFirstName: 'First name is required',
  emptyLastName: 'Last name is required',
  emptyEmail: 'Email is required',
  emptyRole: 'Role is required',
  emptyOrganization: 'Organization is required',
  emptyOrgCode: 'Organization code is required',
  orgCodeLength: 'Organization code length should be 2 to 16',
  emptyOrgName: 'Organization name is required',
  emptyDrivePath: 'Drivepath is required',
  emptyTotalMemory: 'Total memory is required',
  emptyTotalMemoryType: 'Memory type is required!',
  negativeTotalMemory: 'Total memory cannot be negative',
  emptyDriveType: 'Drivetype is required',
  drivePathLength: 'Drivepath length should be max 255',
  driveCodeLength: 'Code length should be max 16',
  emptyDriveCode: 'Code is required',
  orgNameLength: 'Org name length should be 2 to 64',
  userFirstNameLength: 'User first name should be 2 to 64',
  userLastNameLength: 'User last name should be 2 to 64',
  userValidMail: 'Invalid email address.',
  userPasswordLength: 'Password length should be 12 to 38.',
  emptyOrgRole: 'Role name is required',
  orgRoleNameLength: 'Organization role name length should be 2 to 128.',
  emptyWebsite: 'Site url is required',
  emptyName: 'Name is required',
  siteValidLengthName: 'Name length should be max 50',
  emptyNoiseWord: 'Noise word required',
  noiseWordLength: 'Noise word length should be max 32',
  emptyCurrentPassword: 'Current password required',
  emptyNewPassword: 'New password required',
  emptyConfirmPassword: 'Confirm new password required',
  passwordNotMatching: 'New password and confirm password not matching',
  passwordLength: 'Password length should be 12 to 38',
  emptyCategory: 'Category is required',
  emptyCategoryLabel: 'Category label is required',
  categoryLabelLength: 'Category label length should be 2 to 32',
  categoryLength: 'Category name should be should be 2 to 160',
  sessionExpired: 'Session expired, please login again',
  dataStorePath: 'Data store path is required',
  fileStoreDriveCode: 'File store drive code is required',
  emptyOrganizationRole: 'Organization role required!',
  emptyKeyword: 'Keyword is required',
  keywordLength: 'Keyword should be 2 to 500.',
};
